import React from "react";
import { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // For carousel styling
import { FaHotel, FaUtensils, FaSwimmingPool } from "react-icons/fa";
import { useSelector } from "react-redux";
import singapur from "../assets/places/singapur/singapur.jpg";
import CustomizedForm from "../components/OrderPopup/Forms";

const Hotels = () => {
  const theme = useSelector((state) => state.theme.theme); // Assuming 'currentTheme' holds 'dark' or 'light'
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const themeClasses = theme === "dark" ? "bg-black text-white" : "bg-white text-gray-900";
  const cardClasses = theme === "dark" ? "bg-[#5b53fb] text-white" : "bg-[#dcdafc] text-gray-900";

  return (
    <div className={`${themeClasses} min-h-screen`}>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[60vh] flex items-center justify-center"
        style={{
          backgroundImage: `url(${singapur})`,
        }}
      >
        <div
          className={`${
            theme === "dark" ? "bg-black bg-opacity-50" : "bg-white bg-opacity-75"
          } p-8 rounded-md text-center shadow-lg`}
        >
          <h1 className="text-4xl font-bold text-[#5b53fb]">Book Your Hotel</h1>
          <p className="mt-2 text-lg font-light">
            Find luxurious stays and unbeatable offers at top destinations.
          </p>
        </div>
      </div>

      {/* Carousel Section */}
      <section className="py-8">
        <h2 className="text-2xl font-bold text-[#5b53fb] text-center mb-6">
          Exclusive Hotel Deals
        </h2>
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={3000}
          showStatus={false}
        >
          <div className={`flex justify-center items-center p-4 ${cardClasses}`}>
            <FaHotel size={50} className="mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Luxury Hotels</h3>
              <p>Get up to 30% off on 5-star hotel bookings.</p>
            </div>
          </div>
          <div className={`flex justify-center items-center p-4 ${cardClasses}`}>
            <FaUtensils size={50} className="mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Free Breakfast</h3>
              <p>Enjoy complimentary breakfast with selected stays.</p>
            </div>
          </div>
          <div className={`flex justify-center items-center p-4 ${cardClasses}`}>
            <FaSwimmingPool size={50} className="mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Resort Offers</h3>
              <p>Special packages for resorts with pools and spas.</p>
            </div>
          </div>
        </Carousel>
      </section>

      {/* Form Section */}
      <section
        className={`max-w-7xl mx-auto border border-[#5b53fb] rounded-lg shadow-lg p-8 ${
          theme === "dark" ? "bg-black" : "bg-gray-100"
        }`}
      >
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-[#5b53fb]">Hotel Booking Form</h2>
          <p>Fill out the form below to book your perfect stay.</p>
        </div>
        <CustomizedForm name="Book your hotel" />
      </section>

      {/* Additional Info Section */}
      <section className="py-10">
        <h2 className="text-2xl font-bold text-[#5b53fb] text-center mb-6">
          Why Book With Us?
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          <div className={`p-4 rounded-md w-80 text-center ${cardClasses}`}>
            <h3 className="text-lg font-semibold">24/7 Support</h3>
            <p>We're always here to help you find the perfect stay.</p>
          </div>
          <div className={`p-4 rounded-md w-80 text-center ${cardClasses}`}>
            <h3 className="text-lg font-semibold">Best Price Guarantee</h3>
            <p>We ensure you get the most value for your money.</p>
          </div>
          <div className={`p-4 rounded-md w-80 text-center ${cardClasses}`}>
            <h3 className="text-lg font-semibold">Handpicked Stays</h3>
            <p>Top-rated hotels and resorts for unforgettable experiences.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hotels;
